import React, { Component } from "react";
import { Follow } from "react-twitter-widgets";
import "./UserInfo.css";

class UserInfo extends Component {
  render() {
    const { userName, userLocation, userTwitter } = this.props.config;
    return (
      <div className="UserInfo">
        <h4>{userName}</h4>
        <p>{userLocation}</p>
        <Follow
          username={userTwitter}
        />
      </div>
    );
  }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/UserInfo/UserInfo.jsx